import React, { useContext, useRef, useState } from "react";
import { Button, Tooltip, Overlay } from "react-bootstrap";
import { AuthContext } from "../../../context/AuthContext";

const ButtonImagePermission = ({ className, buttonImage, tooltipImage, disabled, permission, onClick }) => {
  const { isAllowed } = useContext(AuthContext);
  const target = useRef(null);
  const [showTootip, setShowTooltip] = useState(false);
  const allowed = isAllowed(permission);

  return (
    <>
      <div ref={target} onPointerEnter={() => setShowTooltip(true)} onPointerLeave={() => setShowTooltip(false)}>
        <Button disabled={!allowed || disabled} variant="bg-transparent" className={className} onClick={onClick}>
          {buttonImage}
        </Button>
      </div>
      <Overlay target={target.current} show={showTootip} placement="top">
        <Tooltip>{allowed ? tooltipImage : "Acesso Negado"}</Tooltip>
      </Overlay>
    </>
  );
};

export default ButtonImagePermission;
